"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resources = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _knock_sound = _interopRequireDefault(require("./wavs/knock_sound.wav"));
var _sceneLayoutFeaturedMedia = _interopRequireDefault(require("./images/scene-layout-featured-media.png"));
var _sceneLayoutFeaturedPresenter = _interopRequireDefault(require("./images/scene-layout-featured-presenter.png"));
var _sceneLayoutFeaturedScreen = _interopRequireDefault(require("./images/scene-layout-featured-screen.png"));
var _sceneLayoutGrid = _interopRequireDefault(require("./images/scene-layout-grid.png"));
var _sceneLayoutSideBySide = _interopRequireDefault(require("./images/scene-layout-side-by-side.png"));
var _sceneLayoutSingle = _interopRequireDefault(require("./images/scene-layout-single.png"));
var _svgComponents = _interopRequireDefault(require("./svgComponents"));
var _gridLightFocus = _interopRequireDefault(require("./svg/grid-light-focus.svg"));
var _gridLightHover = _interopRequireDefault(require("./svg/grid-light-hover.svg"));
var _gridLightActive = _interopRequireDefault(require("./svg/grid-light-active.svg"));
var _gridLightDefault = _interopRequireDefault(require("./svg/grid-light-default.svg"));
var _gridLightDisabled = _interopRequireDefault(require("./svg/grid-light-disabled.svg"));
var _sideBySideLightFocus = _interopRequireDefault(require("./svg/side-by-side-light-focus.svg"));
var _sideBySideLightHover = _interopRequireDefault(require("./svg/side-by-side-light-hover.svg"));
var _sideBySideLightActive = _interopRequireDefault(require("./svg/side-by-side-light-active.svg"));
var _sideBySideLightDefault = _interopRequireDefault(require("./svg/side-by-side-light-default.svg"));
var _sideBySideLightDisabled = _interopRequireDefault(require("./svg/side-by-side-light-disabled.svg"));
var _featuredPresenterLightFocus = _interopRequireDefault(require("./svg/featured-presenter-light-focus.svg"));
var _featuredPresenterLightHover = _interopRequireDefault(require("./svg/featured-presenter-light-hover.svg"));
var _featuredPresenterLightActive = _interopRequireDefault(require("./svg/featured-presenter-light-active.svg"));
var _featuredPresenterLightDefault = _interopRequireDefault(require("./svg/featured-presenter-light-default.svg"));
var _featuredPresenterLightDisabled = _interopRequireDefault(require("./svg/featured-presenter-light-disabled.svg"));
var _activeSpeakerWhite = _interopRequireDefault(require("./gif/active-speaker-white.gif"));
var _activeSpeakerGreen = _interopRequireDefault(require("./gif/active-speaker-green.gif"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var resources = exports.resources = _objectSpread(_objectSpread({
  knockSound: _knock_sound["default"],
  sceneLayoutFeaturedMedia: _sceneLayoutFeaturedMedia["default"],
  sceneLayoutFeaturedPresenter: _sceneLayoutFeaturedPresenter["default"],
  sceneLayoutFeaturedScreen: _sceneLayoutFeaturedScreen["default"],
  sceneLayoutGrid: _sceneLayoutGrid["default"],
  sceneLayoutSideBySide: _sceneLayoutSideBySide["default"],
  sceneLayoutSingle: _sceneLayoutSingle["default"]
}, _svgComponents["default"]), {}, {
  gridLightFocus: _gridLightFocus["default"],
  gridLightHover: _gridLightHover["default"],
  gridLightActive: _gridLightActive["default"],
  gridLightDefault: _gridLightDefault["default"],
  gridLightDisabled: _gridLightDisabled["default"],
  sideBySideLightFocus: _sideBySideLightFocus["default"],
  sideBySideLightHover: _sideBySideLightHover["default"],
  sideBySideLightActive: _sideBySideLightActive["default"],
  sideBySideLightDefault: _sideBySideLightDefault["default"],
  sideBySideLightDisabled: _sideBySideLightDisabled["default"],
  featuredPresenterLightFocus: _featuredPresenterLightFocus["default"],
  featuredPresenterLightHover: _featuredPresenterLightHover["default"],
  featuredPresenterLightActive: _featuredPresenterLightActive["default"],
  featuredPresenterLightDefault: _featuredPresenterLightDefault["default"],
  featuredPresenterLightDisabled: _featuredPresenterLightDisabled["default"],
  activeSpeakerWhiteGif: _activeSpeakerWhite["default"],
  activeSpeakerGreenGif: _activeSpeakerGreen["default"]
});